import React from 'react'
import css from '../../../../styles/PwaConstructor.module.scss';

const BlockLine = () => {
  return <div className={css.blockLine}/>
}

export default BlockLine;